import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import InputWithButton from '../Common/InputWithButton/InputWithButton';
import Button from '../Common/Button';

const ForgotPasswordForm = ({username, onSubmit, onChange, isSubmitted, isFormValid}) => {
    return (
        <div className="forgot-password-page">
            <h2>Forgot Password</h2>
            {
                isSubmitted ?
                
                <div>
                    <p>If the username is found for an active account, an email will be sent to you with a link to reset your password. Please click the link in the email to continue. If you need additional assistance, contact your administrator or email <a href="mailto:support@getpacer.com">support@getpacer.com</a>.</p>
                    <NavLink className="nav-link" to="/Login">
                        <Button 
                            type="submit"
                            bootstrapClass="outline-light"
                            text="Go to Sign In"
                        />
                    </NavLink>
                </div>
        
                :

                <form onSubmit={onSubmit} className={ isFormValid ? "" : "was-validated"} noValidate>
                    <p>Please enter your username.</p>
                    <InputWithButton
                        name="Username"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={onChange}
                        errorMessage="Please enter a username"
                        isRequired={true}
                        isFocused={true}
                        showButton={true}
                        onButtonClick={onSubmit} />
                    
                </form>
            }
        </div>
    );
};

ForgotPasswordForm.propTypes = {
    username: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
    isFormValid: PropTypes.bool.isRequired
};

export default ForgotPasswordForm;